export default class _DTO {

  static getOrDefault(data, field, defaultValue) {
    return field in (data || {}) ? data[field] : defaultValue;
  }

  static getMappedOrDefault(data, field, defaultValue, mapper) {
    return (field in data && data[field] != null) ? mapper(data[field]) : defaultValue;
  }
}
